// 计算太阳能板一年发电量
// power: 太阳能板瓦数  n: 太阳能板数量 365天 平均每天6h 返回kwh
export const calcTotalEnergy = (power: number, n: number) => Math.round((power / 1000) * 365 * 6 * n);
// 计算省钱额度 0.318 美国电费最贵州的费率  南非ZA费率为2.07
export const calcTotalSave = (power: number, n: number, locale?: string) => Math.round((power / 1000) * 365 * 6 * n * (locale === 'za' ? 2.07 : 0.318));

// 不推荐选择的太阳能板数量
export const getRecommand = (product: string, solar: string) => {
    const MAP: any = {
        deltapro3: {
            '400w': [1, 2, 3, 4, 5, 6],
            '500w': [1, 2, 3, 4, 5],
            '220w': [1, 2, 3, 4, 5, 6],
            '125w': [1, 2, 3, 4, 5],
        },
        delta2: {
            '400w': [1],
            '220w': [1, 2],
            '160w': [1, 2],
            '110w': [1, 2, 4],
        },
        delta2max: {
            '400w': [1, 2],
            '220w': [1, 2, 3, 4],
            '160w': [1, 2, 3, 4],
            '110w': [2, 3, 4],
        },
        deltapro: {
            '400w': [1, 2, 3],
            '500w': [1, 2, 3],
            '220w': [2, 3, 4],
            '160w': [4],
            '110w': [],
        },
        dp3: {
            '400w': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            '220w': [1, 2, 3, 4, 5, 6, 7],
            '125w': [1, 2, 3, 4, 5],
            '500w': [1, 2, 3, 4, 5],
        },
        dpu: {
            '400w': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            '500w': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
            '2*400w_rigid': [1, 2, 3, 4, 5, 6, 7],
            '400w_rigid': [1, 2, 3, 4, 5, 6, 7],
        },
        d3p: {
            '400w': [1, 2],
            '220w': [1, 2, 3, 4],
            '160w': [1, 2, 3, 4, 5, 6],
            '110w': [1, 2, 3, 4, 5, 6, 7, 8, 9],
        },
        delta3ultraplus: {
            '400w': [1, 2],
            '2*400w': [1],
            '4*125w': [1],
        },
        delta3maxplus: {
            '400w': [1],
            '4*125w': [1],
        },
        delta3ultra: {
            '400w': [1, 2],
            '2*400w': [1],
            '4*125w': [1],
            '2*220w': [1],
        },
        delta3classic: {
            '220w': [1, 2],
            '2*100w_rigid': [1, 2],
        },
        delta3max: {
            '220w': [1, 2],
            '2*220w': [1],
            '400w': [1],
            '4*125w': [1],
        },
        dpux: {
            '400w': [1,2,3],
        },
    };
    return MAP[product][solar];
};
